import { render, staticRenderFns } from "./insertWatermark.vue?vue&type=template&id=bc104a2c&scoped=true"
import script from "./insertWatermark.vue?vue&type=script&lang=js"
export * from "./insertWatermark.vue?vue&type=script&lang=js"
import style0 from "./insertWatermark.vue?vue&type=style&index=0&id=bc104a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc104a2c",
  null
  
)

export default component.exports